import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';

export class SettingsApiService extends ApiService {
  static endpoint = 'settings';

  /**
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(), {
      ...config,
      dataModel: null,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
